import React, { useState } from "react";
import axios from "axios";
import { DatePicker, Upload, Select, Spin, Modal, message, Button, Space } from 'antd';
import {
  UploadOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  DownloadOutlined,
  LockOutlined,
  CrownOutlined,
  ClockCircleOutlined,
  ExportOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileImageOutlined
} from '@ant-design/icons';
import * as NwfaVerifyService from "../../services/NwfaVerifyService";
import { MEDIA_UPLOAD_URL } from "../../Helper";
import moment from 'moment';
import { useDispatch } from "react-redux";


const Repeater = (props) => {
  var dispatch = useDispatch();
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const DateFormat = 'MM-DD-YYYY';
  const OPTIONS = [
    {
      key: 1,
      value: 'IICRC Certified',
      label: <>
        <div className='row select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2021/08/IICRC-Logo.png" alt="not found" />
          </div>
          <div className='col-11'>
            IICRC Certified
          </div>
        </div>
      </>
    },
    {
      key: 2,
      value: 'IFCII',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2021/08/IFCII-Logo.jpg" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            IFCII
          </div>
        </div>
      </>
    },
    {
      key: 3,
      value: 'FCITS',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2021/09/FCITS-Logo.png" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            FCITS
          </div>
        </div>
      </>
    },
    {
      key: 4,
      value: 'NWFA',
      disabled: props.nwfaCertified !== "1" ? true : false,
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2022/01/NWFA.png" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            NWFA Inspector
          </div>
        </div>
      </>
    },
    {
      key: 5,
      value: 'NWFA Wood Flooring',
      disabled: props.nwfaCertified !== "1" ? true : false,
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2021/08/NWFA-Logo.jpg" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            NWFA Wood Flooring
          </div>
        </div>
      </>
    },
    {
      key: 7,
      value: 'CFIU',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2021/08/CFIU_Logo-1-1.png" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            CFI University
          </div>
        </div>
      </>
    },
    {
      key: 8,
      value: 'Stone Forensics',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2021/08/stone-forensics-logo.png" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            Stone Forensics
          </div>
        </div>
      </>
    },
    {
      key: 9,
      value: 'NICFI',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2021/08/NICFI-Logo.jpg" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            NICFI
          </div>
        </div>
      </>
    },
    {
      key: 10,
      value: 'NFIC',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2021/08/NFIC-Logo.jpg" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            NFIC
          </div>
        </div>
      </>
    },
    {
      key: 11,
      value: 'CTEF',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2021/08/CTEF-Logo.png" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            CTEF
          </div>
        </div>
      </>
    },
    {
      key: 12,
      value: 'Inspector Training Services',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2022/03/25f32954-46ff-43c1-ba33-9ef95541dc96.gif" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            Inspector Training Services
          </div>
        </div>
      </>
    },
    {
      key: 13,
      value: 'WoolSafe',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2021/10/WoolSafe-logo.jpg" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            WoolSafe
          </div>
        </div>
      </>
    },
    {
      key: 14,
      value: 'NALFA',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://www.floordetective.com/wp-content/uploads/2022/03/NALFA-Logo.jpg" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            NALFA
          </div>
        </div>
      </>
    },
    {
      key: 15,
      value: 'ICRI',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2023/03/04012715/image-30.png" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            ICRI
          </div>
        </div>
      </>
    },
    {
      key: 16,
      value: 'Nafct',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2023/03/27020003/nafct_logo.png" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            Nafct
          </div>
        </div>
      </>
    },
    {
      key: 17,
      value: 'CFI',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2024/03/04021626/cfi-image65e575487546a65e57548754f9.jpg" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            CFI
          </div>
        </div>
      </>
    },
    {
      key: 18,
      value: 'CTI',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2024/03/04021638/CTILogo_FINAL_Color65e575547bc4765e575547bcd4.jpg" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            CTI
          </div>
        </div>
      </>
    },
    {
      key: 19,
      value: 'Walkway Auditor Certificate Holder',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2026/05/06041634/WACH-logo69faf8e23122969faf8e2312b7.png" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            Walkway Auditor Certificate Holder
          </div>
        </div>
      </>
    },
    {
      key: 20,
      value: 'CCI Certified',
      label: <>
        <div className='row  select-dropdown-row'>
          <div className='col-1'>
            <img className='Certification-icon-img' src="https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2026/09/28051334/image-2026-09-28T133941.1296aba2fbe41ccb6aba2fbe41d78.png" width="20" height="20" alt="not found" />
          </div>
          <div className='col-11'>
            CCI Certified
          </div>
        </div>
      </>
    },
  ];

  const uploadImage = async (options, index) => {
    const { onSuccess, onError, file } = options;
    const updatedItems = [...props.items];
    updatedItems[index].loading = true; // Assuming API returns the file URL
    props.setItems(updatedItems);
    const fmData = new FormData();
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    };
    fmData.append('file', file);
    try {
      const res = await axios.post(MEDIA_UPLOAD_URL, fmData, config);
      onSuccess(res.data.id);
      updatedItems[index].file = res.data.source_url; // Assuming API returns the file URL
      updatedItems[index].file_id = res.data.id;
      updatedItems[index].loading = false;
      props.setItems([...updatedItems]);
      message.success("Certificate uploaded successfully!");
    } catch (err) {
      console.error('Error: ', err);
      updatedItems[index].loading = false;
      props.setItems([...updatedItems]);
      message.error("Failed to upload certificate. Please try again.");
      onError(err);
    }
  };

  const handleDateChange = (index, date) => {
    let expDate;
    if (date) {
      expDate = moment(date).format('MM-DD-YYYY');
    } else {
      expDate = undefined;
    }

    const updatedItems = [...props.items];
    updatedItems[index].date = expDate;
    props.setItems(updatedItems);
  };
  const handleCertChange = (index, value) => {
    const updatedItems = [...props.items];
    updatedItems[index].certification_authority = value;
    props.setItems(updatedItems);
    if ((value === "NWFA Wood Flooring" || value === "NWFA") && props.nwfaCertified !== '1') {
      showVerifyPopup(updatedItems);
    }
  };

  const showVerifyPopup = (values) => {
    Modal.info({
      title: 'NWFA Certification will be verified by the administrator before it can be added to your listing.',
      icon: <ExclamationCircleOutlined />,
      content: (
        <div>
          <p>This ensures the credibility and authenticity of the certification.</p>
        </div>
      ),
      onOk() {
        return new Promise((resolve, reject) => {
          setTimeout(resolve, 1000);
          dispatch(NwfaVerifyService.sendVerfyEmail(values))
            .then((res) => {
              message.success("Verification request sent to admin!");
            })
            .catch((err) => {
              console.log('Oops errors!');
            });
        });
      },
    });
  };

  const handleAddItem = () => {
    props.setItems([...props.items, { file: null, certification_authority: '', date: new Date() }]);
  };

  const handleRemoveItem = (index) => {
    const updatedItems = [...props.items];
    updatedItems.splice(index, 1);
    props.setItems(updatedItems);
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: 'none',
      }}
      type="button"
    >
      <UploadOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );
  const getFileType = (url = '') => {
    const cleanUrl = url.toLowerCase().split('?')[0];
    if (cleanUrl.endsWith('.pdf')) return 'pdf';
    if (cleanUrl.endsWith('.docx') || cleanUrl.endsWith('.doc')) return 'docx';
    return 'image';
  };

  const handleViewCertificate = (fileUrl, authority = 'Certificate') => {
    setPreviewFile({
      url: fileUrl,
      authority: authority || 'Certificate'
    });
    setPreviewModalVisible(true);
  };
  const handleDownloadCertificate = (fileUrl) => {
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'certificate'; // You might want to extract the filename from the URL
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <div>
      {props.items.map((item, index) => (
        <div className='file-Repeater row' key={index}>
          <div className='col-md-3 mb-3'>
            <Upload
              name="avatar"
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              disabled={Boolean(item.loading)}
              customRequest={(options) => uploadImage(options, index)}
            >
              {item.file ? (
                <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {item.file.toLowerCase().endsWith('.pdf') ? (
                    <img
                      src="https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2024/03/13062734/PDF_file_icon.svg_65f17f92c093265f17f92c09d7.png"
                      alt="PDF icon"
                      style={{ width: "100%", height: "70px", objectFit: "contain" }}
                    />
                  ) : item.file.toLowerCase().endsWith('.docx') || item.file.toLowerCase().endsWith('.doc') ? (
                    <img
                      src="https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2024/03/13062726/824298865f17f8c0ccdf65f17f8c0cd69.png"
                      alt="DOCX/DOC icon"
                      style={{ width: "100%", height: "70px", objectFit: "contain" }}
                    />
                  ) : (
                    <img
                      src={item.file}
                      alt="avatar"
                      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                  )}
                  {item.loading && (
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: 'rgba(255, 255, 255, 0.88)',
                      backdropFilter: 'blur(2px)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 10,
                      borderRadius: '4px'
                    }}>
                      <Spin size="default" />
                      <span style={{ fontSize: '11px', color: '#0a497b', fontWeight: 600, marginTop: '6px' }}>
                        Uploading...
                      </span>
                    </div>
                  )}
                </div>
              ) : (
                item.loading ? (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                    <Spin size="default" />
                    <span style={{ fontSize: '11px', color: '#0a497b', fontWeight: 600 }}>Uploading...</span>
                  </div>
                ) : (
                  uploadButton
                )
              )}
            </Upload>
            {item.file && (
              <div className="file-actions" style={{ fontSize: '20px', marginLeft: '25px', cursor: 'pointer' }}>
                <EyeOutlined
                  style={{ fontSize: '20px', marginRight: '10px', cursor: 'pointer' }}
                  onClick={() => handleViewCertificate(item.file, item.certification_authority)}
                  title="View Certificate"
                />
                <DownloadOutlined
                  style={{ fontSize: '20px', cursor: 'pointer' }}
                  onClick={() => handleDownloadCertificate(item.file)}
                  title="Download Certificate"
                />
              </div>
            )}
          </div>
          <div className='col-md-4 mb-3'>
            <Select
              placeholder="Select Certification"
              value={item.certification_authority}
              onChange={(value) => handleCertChange(index, value)}
              style={{ width: '100%' }}
              options={OPTIONS.map((item) => ({
                value: item.value,
                label: item.label,
              }))}
            />
          </div>
          <div className='col-md-3 mb-3'>
            <DatePicker
              format={DateFormat}
              value={item.date !== "" && item.date !== null ? moment(item.date) : undefined}
              onChange={(date) => handleDateChange(index, date)}
            />
          </div>
          <div className='col-md-2 mb-3'>
            <button type='button' className='remove-btn' onClick={() => handleRemoveItem(index)}>Remove</button>
            {props.nwfaCertified !== "1" && (item.certification_authority === "NWFA Wood Flooring" || item.certification_authority === "NWFA") && (
              <span
                style={{
                  marginTop: '8px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                  padding: '4px 8px',
                  fontSize: '11px',
                  fontWeight: 600,
                  color: '#b45309',
                  backgroundColor: '#fffbeb',
                  border: '1px solid #fde68a',
                  borderRadius: '12px',
                  lineHeight: '1.2',
                  boxShadow: '0 1px 2px rgba(180, 83, 9, 0.08)',
                  whiteSpace: 'nowrap'
                }}
              >
                <ClockCircleOutlined style={{ fontSize: '11px', color: '#d97706' }} />
                Pending Review
              </span>
            )}
          </div>
        </div>
      ))}
      {props.isFreeInspector && props.items && props.items.length >= 1 ? (
        <div style={{ marginTop: '16px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <button
            type='button'
            className='add-item-rep'
            onClick={() => props.onUpgrade && props.onUpgrade('Unlimited Certifications & Badges')}
            style={{
              background: '#f0f7ff',
              color: '#0a497b',
              borderColor: '#bfdbfe',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              cursor: 'pointer',
              fontWeight: 600
            }}
          >
            <CrownOutlined /> Upgrade to Add More
          </button>
          <span style={{ color: '#64748b', fontSize: '12px' }}>
            1 certification included on Free Plan. Upgrade to add unlimited credentials.
          </span>
        </div>
      ) : (
        <button type='button' className='add-item-rep' onClick={handleAddItem}>Add Item</button>
      )}

      {/* Certificate Document Preview Modal */}
      <Modal
        className="certificate-preview-modal"
        centered
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: 6,
                background: previewFile && getFileType(previewFile.url) === 'pdf' ? '#fef2f2' : (previewFile && getFileType(previewFile.url) === 'docx' ? '#eff6ff' : '#f0fdf4'),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: previewFile && getFileType(previewFile.url) === 'pdf' ? '#dc2626' : (previewFile && getFileType(previewFile.url) === 'docx' ? '#2563eb' : '#16a34a'),
                fontSize: 14,
              }}
            >
              {previewFile && getFileType(previewFile.url) === 'pdf' ? (
                <FilePdfOutlined />
              ) : previewFile && getFileType(previewFile.url) === 'docx' ? (
                <FileWordOutlined />
              ) : (
                <FileImageOutlined />
              )}
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', lineHeight: 1.2 }}>
                {previewFile?.authority || 'Certificate Preview'}
              </div>
              <div style={{ fontSize: 11, color: '#64748b', lineHeight: 1.2 }}>
                {previewFile && getFileType(previewFile.url) === 'pdf' ? 'PDF Document' : (previewFile && getFileType(previewFile.url) === 'docx' ? 'Word Document' : 'Image File')}
              </div>
            </div>
          </div>
        }
        open={previewModalVisible}
        onCancel={() => {
          setPreviewModalVisible(false);
          setPreviewFile(null);
        }}
        width="88%"
        style={{ maxWidth: 880, paddingBottom: 0 }}
        bodyStyle={{
          height: '70vh',
          padding: 0,
          background: '#f8fafc',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
        footer={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px', background: '#ffffff' }}>
            <Space size="small">
              {previewFile?.url && (
                <>
                  {getFileType(previewFile.url) !== 'docx' && (
                    <Button
                      icon={<ExportOutlined />}
                      onClick={() => window.open(previewFile.url, '_blank')}
                      style={{ borderRadius: 6, fontSize: 13, height: 32 }}
                    >
                      Open in New Tab
                    </Button>
                  )}
                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    onClick={() => handleDownloadCertificate(previewFile.url)}
                    style={{ background: '#0a497b', borderColor: '#0a497b', borderRadius: 6, fontWeight: 600, fontSize: 13, height: 32 }}
                  >
                    Download File
                  </Button>
                </>
              )}
            </Space>
            <Button
              onClick={() => {
                setPreviewModalVisible(false);
                setPreviewFile(null);
              }}
              style={{ borderRadius: 6, fontSize: 13, height: 32 }}
            >
              Close
            </Button>
          </div>
        }
      >
        {previewFile?.url ? (
          getFileType(previewFile.url) === 'pdf' ? (
            <iframe
              src={previewFile.url}
              title={previewFile.authority || 'Certificate PDF'}
              width="100%"
              height="100%"
              style={{ border: 'none', display: 'block', flex: 1 }}
            />
          ) : getFileType(previewFile.url) === 'docx' ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              padding: '16px',
            }}>
              <div style={{
                background: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '14px',
                padding: '28px 24px',
                maxWidth: '420px',
                width: '100%',
                boxShadow: '0 4px 16px -2px rgba(15, 23, 42, 0.05)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '12px',
                textAlign: 'center'
              }}>
                <div style={{
                  width: 56,
                  height: 56,
                  borderRadius: 12,
                  background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
                  border: '1px solid #bfdbfe',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#1d4ed8',
                  fontSize: 26,
                  boxShadow: '0 4px 12px -2px rgba(37, 99, 235, 0.15)'
                }}>
                  <FileWordOutlined />
                </div>
                <div>
                  <div style={{
                    display: 'inline-block',
                    background: '#eff6ff',
                    color: '#1d4ed8',
                    fontSize: '10px',
                    fontWeight: 700,
                    padding: '2px 8px',
                    borderRadius: '10px',
                    letterSpacing: '0.5px',
                    marginBottom: '6px',
                    textTransform: 'uppercase'
                  }}>
                    Word Document
                  </div>
                  <h4 style={{ margin: '0 0 6px 0', color: '#0f172a', fontSize: '15px', fontWeight: 700 }}>
                    {previewFile.authority || 'Certificate Document'}
                  </h4>
                  <p style={{ color: '#64748b', fontSize: '12px', lineHeight: '1.5', margin: 0 }}>
                    Direct browser preview is not supported for Word (.docx) files. Click Download File below to view this certificate.
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div style={{
              width: '100%',
              height: '100%',
              padding: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <img
                src={previewFile.url}
                alt={previewFile.authority || 'Certificate Preview'}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                  borderRadius: 8,
                  boxShadow: '0 6px 20px rgba(0, 0, 0, 0.08)',
                  border: '1px solid #e2e8f0',
                  background: '#ffffff'
                }}
              />
            </div>
          )
        ) : null}
      </Modal>
    </div>
  );
};

export default Repeater;
